import React, { useEffect, useState } from "react";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { getStatusStageComponent, isGRN } from "../utils/common";
import useFinanceInventory from "../data-handling/use-finance-inventory";
import {
  IActivityItem,
} from "../data-handling/finance-inventory-types";
import { useDispatch } from "react-redux";
import { getRelatedInventoryActivity } from "../../../redux/slices";
import moment from "moment";
import { DATE_TIME_FORMATS } from "../../../data/constants";
import deleteIcon from "./../../../assets/images/delete.png"
import downloadIcon from "./../../../assets/images/download.png"
import { CircularProgress, IconButton } from "@mui/material";
import { INVENTORY_ACTIVITY_TYPES } from "../data-handling/finance-inventory-constants";
import { currency } from "../../../helpers/common-helper";

type buyerSupplierInfo = {
  businessName: string,
  address: string,
}
const currencySymbol = currency();
function PageMetaData() {
  const { selectedActivityRow, activityDetail, downloadAttachment, deleteAttachment, componentLoaders } =
    useFinanceInventory();
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [relatedActivities, setRelatedActivities] = useState<IActivityItem[]>(
    []
  );
  // const supplierInfo = 

  useEffect(() => {
    dispatch(
      getRelatedInventoryActivity({
        activityId: selectedActivityRow?.systemOrderId,
        callback: (response: any) => {
          setRelatedActivities(response || []);
        },
      })
    );
  }, [activityDetail]);

  const {supplierInfo, recipientInfo} = (() => {
    let supplierInfo: buyerSupplierInfo = {address: "", businessName: ""}
    let recipientInfo: buyerSupplierInfo = {address: "", businessName: ""}
    if ([INVENTORY_ACTIVITY_TYPES.goods_received_note, INVENTORY_ACTIVITY_TYPES.post_final_goods_received_note].includes(activityDetail?.activityType || "")) {
      const supplierObject = activityDetail?.supplierInfo || activityDetail?.info;
      const recipientObject = activityDetail?.header;

      supplierInfo.businessName = supplierObject?.businessName || ""
      supplierInfo.address = `${supplierObject?.address.addressLine}, ${supplierObject?.address.city}, ${supplierObject?.address.state}`

      recipientInfo.businessName = recipientObject?.branchName || ""
      recipientInfo.address = `${recipientObject?.branchAddress.addressLine}, ${recipientObject?.branchAddress.city}, ${recipientObject?.branchAddress.state}`
    } else {
      const supplierObject = activityDetail?.header;
      const recipientObject = activityDetail?.targetBranchInfo || activityDetail?.supplierInfo || activityDetail?.info; // due to backend using different keys for different scenarios (dont change priority)

      supplierInfo.businessName = supplierObject?.branchName || ""
      supplierInfo.address = `${supplierObject?.branchAddress.addressLine}, ${supplierObject?.branchAddress.city}, ${supplierObject?.branchAddress.state}`

      recipientInfo.businessName = recipientObject?.branchName || ""
      recipientInfo.address = `${recipientObject?.address.addressLine}, ${recipientObject?.address.city}, ${recipientObject?.address.state}`
    }

    return {supplierInfo, recipientInfo}
  })()

  return (
    <div className="p-16 px-32 border-t border-solid border-[#E8E8E9]">
      {relatedActivities?.length > 0 && (
        <div className="border border-1 bg-white rounded-[8px] select-none !px-14">
          <div
            className="flex justify-between items-center py-8 cursor-pointer"
            onClick={() => setIsOpen(!isOpen)}
          >
            <h3 className="text-13 font-500">
              {"Related Activities "}
              {`(${relatedActivities?.length})`}
            </h3>
            <KeyboardArrowUpIcon className={isOpen ? "" : "rotate-180"} />
          </div>
          <div className="">
            {isOpen && (
              <table className="w-full border-b border-greyEB text-[11px]">
                <thead className="text-[#7F7F7F]">
                  <tr className="">
                    <th className="text-left p-10">DATE</th>
                    <th className="text-left p-10">ACTIVITY ORDER#</th>
                    <th className="text-left p-10">ACTIVITY TYPE</th>
                    <th className="text-left p-10">SUPPLIED FROM</th>
                    <th className="text-right p-10">TOTAL AMOUNT</th>
                  </tr>
                </thead>
                <tbody>
                  {relatedActivities?.map((row) => (
                    <tr key={row.orderNumber} className="border-t border-greyEB">
                      <td className="p-10">
                        {moment(row.activityDate).format(
                          DATE_TIME_FORMATS.dayMonthYearShort
                        )}
                      </td>
                      <td className="p-10">
                        {row.orderNumber || "--"}
                      </td>
                      <td className="p-10">
                        {row.activityType || "--"}
                      </td>
                      <td className="p-10">{row.supplierName || "--"}</td>
                      <td className="p-10 text-right">
                        {currencySymbol}
                        {row.netCost.toLocaleString("en-IN", {
                          minimumFractionDigits: 2,
                        })}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      )}

      <div className="bg-white rounded-[8px] mt-16">
        <h2 className="text-xl font-semibold mb-4">
          {activityDetail?.header.activityTitle}{" #"}{activityDetail?.orderNumber}
        </h2>
        <div className="flex flex-col justify-between text-sm font-400 text-[14px] mt-20">
          <div className="flex">
            <p className="uppercase w-[300px] font-500 text-[11px] text-[#7F7F7F]">Date</p>
            <div>
              <p>
                {moment(activityDetail?.activityDate).format(
                  DATE_TIME_FORMATS.dayMonthYearShort
                )} {" "}
                {moment(activityDetail?.activityDate).format(
                  DATE_TIME_FORMATS.time)}
              </p>
            </div>
          </div>
          <div className="flex mt-16">
            <p className="uppercase w-[300px] font-500 text-[11px] text-[#7F7F7F]">Status</p>
            <p className="text-[12px] font-500 text-yellow-600"> {activityDetail?.status}</p>
          </div>
          <div className="flex mt-16">
            <p className="uppercase w-[300px] font-500 text-[11px] text-[#7F7F7F]">Approval Stage</p>
            {getStatusStageComponent(activityDetail)}
          </div>
          <div className="flex tracking-wide mt-16">
            <p className="uppercase w-[300px] font-500 text-[11px] text-[#7F7F7F]">Bill Amount</p>
            <p className="font-semibold">{currencySymbol}{activityDetail?.netCost}</p>
          </div>
          <div className="flex tracking-wide mt-16">
            <p className="uppercase w-[300px] font-500 text-[11px] text-[#7F7F7F]">Consignee</p>
            <div>
              <p className="font-semibold">
                {recipientInfo.businessName}
              </p>
              <p className="text-[#00000099]">
                {recipientInfo.address}
              </p>
            </div>
          </div>
          <h2 className="text-xl font-semibold mb-4 mt-20">
            Supplier details
          </h2>
          <div className="flex tracking-wide mt-16">
            <p className="uppercase w-[300px] font-500 text-[11px] text-[#7F7F7F]">Supplier</p>
            <div>
              <p className="font-semibold text-[#000000DE]">
                {supplierInfo.businessName}
              </p>
              <p className="text-[#00000099]">
                {supplierInfo.address}
              </p>
            </div>
          </div>
          {activityDetail?.supplierInvoiceNumber && <div className="flex tracking-wide mt-16">
            <p className="uppercase w-[300px] font-500 text-[11px] text-[#7F7F7F]">Supplier Invoice no.</p>
            <p>{activityDetail.supplierInvoiceNumber}</p>
          </div>}
          {activityDetail?.supplierInvoiceDate && <div className="flex tracking-wide mt-16">
            <p className="uppercase w-[300px] font-500 text-[11px] text-[#7F7F7F]">Supplier Invoice date</p>
            <p>{moment(activityDetail.supplierInvoiceDate).format(DATE_TIME_FORMATS.dayMonthYearShort)}</p>
          </div>}
          {activityDetail?.sourceOrderNumber && <div className="flex tracking-wide mt-16">
            <p className="uppercase w-[300px] font-500 text-[11px] text-[#7F7F7F]">Supplier Invoice no.</p>
            <p>{activityDetail.sourceOrderNumber}</p>
          </div>}
          {activityDetail?.sourceOrderDate && <div className="flex tracking-wide mt-16">
            <p className="uppercase w-[300px] font-500 text-[11px] text-[#7F7F7F]">Supplier Invoice date</p>
            <p>{moment(activityDetail.sourceOrderDate).format(DATE_TIME_FORMATS.dayMonthYearShort)}</p>
          </div>}
        </div>
      </div>

      {!!activityDetail?.attachments?.length && activityDetail.attachments.length > 0 && <div>
        <div className="flex items-start justify-start mt-16">
          <p className="uppercase font-500 text-[11px] mr-8 text-[#7F7F7F]">ATTACHMENTS</p>
          {(componentLoaders.DELETE || componentLoaders.DOWNLOAD) && <CircularProgress className="h-16 w-16" />}
        </div>
        <div className="flex justify-start gap-10 items-center mt-10 flex-wrap">
        {
          activityDetail?.attachments?.map((attachment) => {
            return (<div className="px-8 pl-16 border flex justify-between items-center gap-8 rounded-[8px] border-solid border-[#D9D9D9]">
              <p className="text-black text-[14px]">
                {attachment.fileName}
              </p>
              <div className="ml-8 flex items-center">
                <IconButton onClick={() => deleteAttachment(attachment)}>
                  <img className="h-24 w-22" src={deleteIcon}/>
                </IconButton>
                <IconButton onClick={() => downloadAttachment(attachment)}>
                  <img className="h-24 w-22" src={downloadIcon}/>
                </IconButton>
              </div>
            </div>)
          })
        }
        </div>
      </div>}
    </div>
  );
}

export default PageMetaData;
